import { useMutation } from '@tanstack/react-query';
import { saveDraftContent } from '../../services';

export function useSaveDraftContent() {
  return useMutation(saveDraftContent, { onSuccess: (data) => data });
}
